import { useSuspenseQuery } from "@tanstack/react-query";
import { listingsModel } from "models/listings";
import { useParams } from "react-router-dom";
import { useAuth } from "contexts/auth-provider";
import { usePortalPath } from "hooks/use-portal-path";

export const useRegion = () => {
  const { propertyId } = useParams();
  const { isLandlordOrTenantPath } = usePortalPath();
  const { user } = useAuth();

  // Only the vendor portal is backed by a listing, so only fetch the listing's
  // region there. Other portals (tenant, landlord) resolve region from the
  // authenticated session.
  const { data } = useSuspenseQuery(
    listingsModel.queries.readRegion(
      !isLandlordOrTenantPath ? propertyId : undefined,
    ),
  );

  if (!isLandlordOrTenantPath) {
    return data?.id ?? "AUS";
  }

  return user?.region.id ?? "AUS";
};
